import * as ActionTypes from './ActionTypes';
import initialState from './InitialState';

export default function deliveredImagesGalleryReducer(
    state: any = initialState.deliveredImages,
    action: { type: string; result: any }
): any {
    switch (action.type) {
        case ActionTypes.GET_IMAGES_SUCCESS:
            return {
                ...state,
                list: action.result.images
            };
        default:
            return state;
    }
}

const getDeliveredImagesGallery = (state) => state.deliveredImagesGallery;
export const getDeliveredImagesGalleryList = (state) => getDeliveredImagesGallery(state).list;
